<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品出库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="border-style">基本信息</div>
        <el-form
          :model="item"
          ref="itemform"
          label-width="120px"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="产品型号名称">
                <el-input
                  v-if="item.DciProductModel"
                  v-model.trim="item.DciProductModel.Name"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品型号">
                <el-input
                  v-if="item.DciProductModel"
                  v-model.trim="item.DciProductModel.Number"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="产品SN">
                <el-input v-model.trim="item.SN" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入库日期" prop="StockinAt">
                <el-date-picker
                  v-model="item.StockinAt"
                  style="width: 100%"
                  type="date"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库日期" prop="StockoutAt">
                <el-date-picker
                  v-model="item.StockoutAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保开始日期" prop="QualityStartAt">
                <el-date-picker
                  v-model="item.QualityStartAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                  @change="changeDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="文件系统版本" prop="DciPvProductVersionID">
                <el-select
                  v-model="item.DciPvProductVersionID"
                  filterable
                  default-first-option
                  placeholder="请选择文件系统版本"
                  style="width: 100%"
                >
                  <el-option
                    v-for="Pv in pvList"
                    :value="Pv.ID"
                    :label="Pv.PvName"
                    :key="Pv.ID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保结束日期" prop="QualityEndAt">
                <el-date-picker
                  v-model="item.QualityEndAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col>
              <el-form-item label="客户名称" prop="ClientName">
                <el-select
                  v-model="item.ClientName"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择或输入客户"
                  style="width: 100%"
                >
                  <el-option
                    v-for="client in clientList"
                    :key="client"
                    :label="client"
                    :value="client"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="标签" prop="Tags">
                <el-select
                  v-model="item.Tags"
                  :multiple-limit="6"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择或创建标签"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(tag, index) in tagList"
                    :key="index"
                    :label="tag"
                    :value="tag"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同编号" prop="ContractNos">
                <!-- <el-input
                  v-model.trim="item.ContractNo"
                  placeholder="请输入合同编号"
                ></el-input> -->
                <el-select
                  v-model="item.ContractNos"
                  multiple
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择或输入合同编号"
                  style="width: 100%"
                >
                  <el-option
                    v-for="contract in contractList"
                    :key="contract"
                    :label="contract"
                    :value="contract"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库单号" prop="CheckoutNo">
                <el-input
                  v-model.trim="item.CheckoutNo"
                  placeholder="请输入出库单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库经办人" prop="Operator">
                <el-input
                  v-model.trim="item.Operator"
                  placeholder="请输入经办人"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="领用部门" prop="RecipientDeptID">
                <select2
                  style="width: 100%"
                  v-model="item.RecipientDeptID"
                  url="department"
                  :clearable="false"
                  placeholder="请选择部门"
                  no-data-text="没有部门"
                  :urlParams="{
                    where: {},
                  }"
                  q="Name:like"
                  :qinwhere="true"
                  :queryOne="false"
                ></select2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="领用人" prop="Recipient">
                <el-input
                  v-model.trim="item.Recipient"
                  placeholder="请输入领用人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="出库备注" prop="StockoutReason">
            <el-input
              v-model.trim="item.StockoutReason"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入出库备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <div class="border-style">日志信息</div>
        <div class="dialogDiv">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>

    <div class="border-style">相关配件</div>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateClick">
        <i class="fas fa-plus"></i> 新增配件
      </el-button>
    </div>
    <el-table :data="acList" v-loading="loading">
      <el-table-column prop="DciAccessoryModel.Name" label="配件型号名称" />
      <el-table-column prop="DciAccessoryModel.Number" label="配件型号" />
      <el-table-column prop="SN" label="配件SN" />
      <el-table-column width="80" label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <el-dialog
      title="选择配件"
      :visible.sync="accvisible"
      append-to-body
      :close-on-click-modal="false"
      @close="accvisible = false"
      width="30%"
    >
      <el-form
        ref="accItemForm"
        label-width="100px"
        :model="accItem"
        :rules="accRules"
      >
        <el-form-item label="配件SN" prop="AccessoryID">
          <select2
            labelName="SN"
            v-model="accItem.AccessoryID"
            url="dci/product/stock-canuse-acc-list"
            :clearable="true"
            placeholder="选择配件SN"
            no-data-text="没有配件SN"
            style="width: 100%"
            :urlParams="{
              where: {},
            }"
            q="SN:like"
            :qinwhere="true"
            :queryOne="false"
          ></select2
          >&nbsp;
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="accvisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onCreateItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      loading: false,
      rules: {
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        DciPvProductVersionID: [
          { required: true, message: "文件系统版本不能为空", trigger: "blur" },
        ],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        ContractNos: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        // Operator: [
        //   { required: true, message: '出库经办人不能为空', trigger: 'blur' },
        // ],
        RecipientDeptID: [
          { required: true, message: "领用部门不能为空", trigger: "blur" },
        ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      activities: [], //日志
      tagList: [], //标签
      clientList: [], //客户
      contractList: [], //合同
      pvList: [], //文件系统版本
      acList: [], //相关配件
      accvisible: false,
      accItem: {
        AccessoryID: null,
        ProductID: null,
      },
      accRules: {
        AccessoryID: [
          { required: true, message: "配件SN不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      const date = new Date();
      this.item.StockoutAt = date;
      this.item.QualityStartAt = date;
      this.item.QualityEndAt = new Date(
        date.getTime() + 3600 * 1000 * 24 * 365
      );
      this.item.Operator = this.$store.state.Auth.user.Name;

      this.item.RecipientDeptID =
        this.item.RecipientDeptID == 0 ? "" : this.item.RecipientDeptID;
            
      this.getLog();
      this.getTagList();
      this.getClientList();
      this.getContractList();
      this.getPVList();
      this.getAccessoriesList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    getLog() {
      this.$axios
        .get(`dci/product/${this.item.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at", "-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getTagList() {
      this.$axios
        .get("dci/product/stock-tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getClientList() {
      this.$axios
        .get("dci/product/stock-clients")
        .then((response) => {
          this.clientList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getContractList() {
      this.$axios
        .get("dci/product/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //绑定文件系统版本
    getPVList() {
      //根据产品型号自动绑定默认版本
      this.item.DciPvProductVersionID = null;
      this.$axios
        .get("dci/pv/productversion/list", {
          params: {
            dciProductModelID: this.item.DciProductModelID, //产品型号id
            order: ["-pv_name"],
            total: 0,
            page: 1,
            size: -1,
          },
        })
        .then((response) => {
          for (const pv of response.data.data) {
            if (pv.IsDefault) {
              this.item.DciPvProductVersionID = pv.ID;
              pv.PvName = pv.PvName + "【默认】";
            }
          }
          this.pvList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //产品相关配件
    getAccessoriesList() {
      this.loading = true;
      this.$axios
        .get("dci/accessory/stock-list/list", {
          params: {
            where: {
              DciProductID: this.item.ID,
            },
            with: ["DciAccessoryModel"],
            order: ["-sn"],
          },
        })
        .then((response) => {
          this.acList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.item.QualityStartAt;
        this.item.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.item.QualityEndAt = val;
      }
    },
    //点击增加配件按钮
    onCreateClick() {
      this.accvisible = true;
      this.accItem.AccessoryID = null;
      this.accItem.ProductID = this.item.ID;
    },
    //增加配件
    onCreateItem() {
      this.$refs.accItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/product/stock-out-acc-create",
            method: "post",
            data: this.accItem,
          })
          .then(() => {
            this.accvisible = false;
            this.getAccessoriesList();
            this.$message.success("新增成功");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    //删除配件
    onDeleteItem(row) {
      this.$confirm("确定要删除此配件吗？", "提示")
        .then(() =>
          this.$axios.delete(`dci/product/stock-out-acc-delete/${row.ID}`)
        )
        .then(() => {
          this.$message.success("删除成功");
          this.getAccessoriesList();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //确认出库
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: `dci/product/stock-out/${this.item.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("出库成功");
            this.submitting = false;
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 450px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
